/*
 * "That page does not exist", in two wrappers.
 *
 * NotFoundContent is the body alone, for the kb/* and releasenotes/* catch-alls
 * that sit INSIDE PublicLayout. A one-segment /kb/{slug} link - the shape every
 * reference carried before an article's address gained its product segment - is
 * dead and stays dead, but it is a reader who is following it, so it lands in the
 * site chrome with the header, the footer and a way back rather than on a bare
 * page that reads as the site having fallen over. A mistyped /releasenotes/...
 * path (S42) is treated the same way.
 *
 * NotFoundPage is the same body inside a minimal shell of its own, for the outer
 * "*" route: a URL under none of /kb, /releasenotes and /admin has no layout to
 * sit in, and still needs the skip target and the page padding a layout would
 * have supplied.
 * The two must not be nested - id="main" appears once per document - which is
 * exactly why the body is a component of its own rather than a prop on the page.
 */

import { Link } from 'react-router-dom';
import { EmptyState } from '../components/ui.js';
import { SignInHint } from './SignInHint.js';
import { useMessages } from '../i18n/language.js';

export function NotFoundContent(): JSX.Element {
  const t = useMessages();

  return (
    <EmptyState title={t.notFound.title}>
      <p>{t.notFound.body}</p>
      <SignInHint />
      <p>
        <Link className="button button-primary" to="/">
          {t.notFound.home}
        </Link>
      </p>
    </EmptyState>
  );
}

export function NotFoundPage(): JSX.Element {
  return (
    <div className="app">
      <main id="main">
        <div className="page">
          <NotFoundContent />
        </div>
      </main>
    </div>
  );
}
